export const TYPES_LANGUAGES = {
  CA_ES: 'ca_ES',
  EN_GB: 'en_GB',
  ES_419: 'es_419',
  ES_ES: 'es_ES',
  ES_MX: 'es_MX',
  PL_PL: 'pl_PL',
  SL_SI: 'sl_SI',
}

export const BASIC_LANGUAGES = {
  CA: 'ca',
  EN: 'en',
  ES: 'es',
  PL: 'pl',
  SL: 'sl',
}
